import React, { ReactNode } from 'react';

import { ModalPopup } from '../ModalPopup';
import classNames from 'classnames';

import './ModalDialog.scss';

interface ModalDialogProps {
  children?: ReactNode;
  zIndex?: number;
}

export const ModalDialog: React.FC<ModalDialogProps> = ({ zIndex, children }) => (
  <ModalPopup zIndex={zIndex}>
    <div className={classNames('modal-dialog')}>
      <div className="modal-dialog__panel">{children}</div>
    </div>
  </ModalPopup>
);
